import { wallpapers } from "@/mocks/homeData";
import type { MemeItem } from "@/mocks/homeData";
import SectionHeader from "./SectionHeader";

interface Props {
  onOpen: (item: MemeItem) => void;
}

export default function WallpaperSection({ onOpen }: Props) {
  return (
    <section id="wallpaper" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeader
          eyebrow="高清壁纸"
          title="瓜田美学 装满你的屏幕"
          desc="治愈系、活力系、夜猫系壁纸每周上新，直接下载横屏大图，桌面和手机都好看。"
        />
        <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-3">
          {wallpapers.map((wp) => (
            <button
              key={wp.id}
              type="button"
              onClick={() => onOpen(wp)}
              className="group relative overflow-hidden rounded-2xl bg-background-100 text-left cursor-pointer"
              aria-label={`查看壁纸${wp.title}`}
            >
              <img
                src={wp.img}
                alt={wp.alt}
                className="aspect-video w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-secondary-500 px-3 py-1 text-xs font-semibold text-foreground-950">
                {wp.tag}
              </span>
              <div className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-2 bg-gradient-to-t from-foreground-950/80 to-transparent p-4">
                <div className="min-w-0 text-left">
                  <h4 className="truncate font-heading text-base text-background-50">{wp.title}</h4>
                  <p className="truncate text-xs text-background-50/80">{wp.caption}</p>
                </div>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-background-50/90 text-primary-600 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <i className="ri-zoom-in-line" />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}